import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { IPreferenceVideo } from './video.types';

@Timestampable
@Untrackable
export class PreferenceVideo extends AbstractDocument<IPreferenceVideo> {
  readonly collections = {};
}
